/**
 * Created by YJZX-LCH on 2017-05-16.
 */
const state = {
  imgs: [],
  index: 0
};

const mutations = {
  clearImgInfo(state) {
    state.imgs = [];
    state.index = 0;
  },
  setImgInfo(state, payload) {
    state.imgs = payload.imgs;
    state.index = payload.index;
  }
};

export default {
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/pictureview.js